import { b as __awaiter, c as __generator } from '../tslib.es6-604585c1.js';

function extractUserInfo(data) {
  return __awaiter(this, void 0, void 0, function () {
    var _a, default_profile_pic, _b, has_password, _c, is_activated, _d, registered, _e, account_type, subscription, _f, email, _g, photo, _h, name, username, created, teams, key, id, is_verified, is_new, subscribed, isTrialUsed;
    return __generator(this, function (_j) {
      if (!data) {
        return [2, null];
      }
      _a = data.default_profile_pic, default_profile_pic = _a === void 0 ? false : _a, _b = data.has_password, has_password = _b === void 0 ? false : _b, _c = data.is_activated, is_activated = _c === void 0 ? false : _c, _d = data.registered, registered = _d === void 0 ? false : _d, _e = data.account_type, account_type = _e === void 0 ? '' : _e, subscription = data.subscription, _f = data.email, email = _f === void 0 ? '' : _f, _g = data.photo, photo = _g === void 0 ? '' : _g, _h = data.name, name = _h === void 0 ? '' : _h, username = data.username, created = data.created, teams = data.teams, key = data.key, id = data.id, is_verified = data.is_verified;
      is_new = registered;
      subscribed = subscription && subscription.granted;
      isTrialUsed = subscription ? !!subscription.is_trial_used : false;
      return [2, {
        default_profile_pic: default_profile_pic,
        has_password: has_password,
        account_type: account_type,
        is_activated: is_activated,
        isTrialUsed: isTrialUsed,
        subscribed: subscribed,
        username: username,
        created: created,
        is_new: is_new,
        photo: photo,
        email: email,
        teams: teams,
        name: name,
        key: key,
        id: id,
        is_verified: is_verified
      }];
    });
  });
}

export { extractUserInfo as default };
//# sourceMappingURL=index.js.map
